// extracted by mini-css-extract-plugin
export default {"root":"hM0qUc5p","img":"nMFidzMr"};